import {
  Directive,
  Input,
  OnInit,
  ViewContainerRef,
  Renderer,
  ComponentRef,
  ComponentFactoryResolver,
  HostListener
} from '@angular/core';
import { MdlSimpleTooltipComponent, MdlTooltipComponent } from './mdl-tooltip.component';

export class AbstractMdlTooltipDirective implements OnInit {

  protected tooltip: string|MdlTooltipComponent;
  protected position: 'left' | 'right' | 'top' | 'bottom';

  protected tooltipComponent: MdlSimpleTooltipComponent;

  constructor(
    private vcRef: ViewContainerRef,
    private large: boolean,
    private componentFactoryResolver: ComponentFactoryResolver,
    private renderer: Renderer) {
  }


  public ngOnInit() {
    // if the tooltip is not an instance of MdlTooltipComponent
    // we create a simpleTooltipComponent on the fly.
    if (!(this.tooltip instanceof MdlTooltipComponent)) {

      let cFactory = this.componentFactoryResolver.resolveComponentFactory(MdlSimpleTooltipComponent);
      let cRef: ComponentRef<MdlSimpleTooltipComponent> = this.vcRef.createComponent(cFactory);

      this.tooltipComponent = <MdlSimpleTooltipComponent> cRef.instance;
      this.tooltipComponent.tooltipText = <string>this.tooltip;
      this.configureTooltipComponent();

    } else {
      this.tooltipComponent = <MdlTooltipComponent>this.tooltip;
      this.configureTooltipComponent();
    }

  }



  private configureTooltipComponent() {
    this.tooltipComponent.large = this.large;
    this.tooltipComponent.position = this.position;
  }

  public onMouseEnter(event) {
    this.tooltipComponent.mouseEnter(event);
  }

  
  public onMouseLeave() {
    this.tooltipComponent.mouseLeave();
  }
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onMouseLeave': [{ type: HostListener, args: ['window:touchstart', ] },],
};
}


const host: { [key: string]: string; } = {
  '(mouseenter)': 'onMouseEnter($event)',
  '(touchend)': 'onMouseEnter($event)',
  '(mouseleave)': 'onMouseLeave()'
};



export class MdlTooltipDirective extends AbstractMdlTooltipDirective {

             public tooltip: string|MdlTooltipComponent;
    public position: 'left' | 'right' | 'top' | 'bottom';

  constructor(
    vcRef: ViewContainerRef,
    componentFactoryResolver: ComponentFactoryResolver,
    renderer: Renderer) {
    super(vcRef, false, componentFactoryResolver, renderer);
  }

  public ngOnInit() { super.ngOnInit(); }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mdl-tooltip]',
  host: host
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
{type: ComponentFactoryResolver, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tooltip': [{ type: Input, args: ['mdl-tooltip', ] },],
'position': [{ type: Input, args: ['mdl-tooltip-position', ] },],
};
}


export class MdlTooltipLargeDirective extends AbstractMdlTooltipDirective {

       public tooltip: string|MdlTooltipComponent;
    public position: 'left' | 'right' | 'top' | 'bottom';

  constructor(
    vcRef: ViewContainerRef,
    componentFactoryResolver: ComponentFactoryResolver,
    renderer: Renderer) {
    super(vcRef, true, componentFactoryResolver, renderer);
  }

  public ngOnInit() { super.ngOnInit(); }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mdl-tooltip-large]',
  host: host
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
{type: ComponentFactoryResolver, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tooltip': [{ type: Input, args: ['mdl-tooltip-large', ] },],
'position': [{ type: Input, args: ['mdl-tooltip-position', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
